<div class="container-fluid">

  <app-pagetitle title="Dashboard" [breadcrumbItems]="breadCrumbItems">
  </app-pagetitle>


  <div class="row">
    <div class="row mb-4">
      <div class="col-lg-12">
        <ul class="nav nav-tabs border-bottom" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link fw-bold" [class.active]="activeTab === 'esign'" (click)="switchTab('esign')"
              type="button" role="tab" [attr.aria-selected]="activeTab === 'esign'">
              <i class="bi bi-pen"></i> E-Sign
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link fw-bold" [class.active]="activeTab === 'estamp'" (click)="switchTab('estamp')"
              type="button" role="tab" [attr.aria-selected]="activeTab === 'estamp'">
              <i class="bi bi-stamp"></i> E-Stamp
            </button>
          </li>
        </ul>
      </div>
    </div>

    <!-- Blur Area Start -->
    @if(activeTab == 'estamp'){
    <div class="row">
      <app-e-stamp-dashboard></app-e-stamp-dashboard>
    </div>
    }@else{
    <div class="row">
      <app-e-sign-dashboard></app-e-sign-dashboard>
    </div>
    }

    <!-- Blur Area End -->

  </div>
</div>